<template>
  <!-- Point d'entrée de l'appli -->
  <v-app>
    <SpinnerLoading v-if="global_loading"></SpinnerLoading>

    <div v-if="mainStore.module.isLoaded && !global_loading">
      <TheHeader></TheHeader>
      <v-container class="pt-0 pb-5">

        <!-- <div class="spo-card pa-2 rounded elevation-0 bordered">
          <v-icon icon="mdi-information-outline" color="red-darken-4" size="xs-small"></v-icon>
          <span class="text-red-darken-4 font-weight-bold">
            Suite à un dysfonctionnement du coté de la FFA, les licences FFA et PPS ne peuvent actuellement pas être
            validés, vous pourrez les insérer plus tard lorsque la situation sera revenue à la normale
          </span>
        </div> -->
      </v-container>
      <router-view />
      <NotificationSystem></NotificationSystem>
      <v-snackbar v-model="show_snackbar_vip_not_valid">
        {{ status_vip }}
        <template v-slot:actions>
          <v-btn color="primary-dark" variant="text" @click="show_snackbar_vip_not_valid = false"> Fermer </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from './stores/bookingStore';
import { useGroupeStore } from './stores/groupeStore';
import TheHeader from "@/components/App/TheHeader.vue";
import NotificationSystem from "@/components/App/NotificationSystem.vue";
import SpinnerLoading from "@/components/App/SpinnerLoading.vue";

import WaitingQueueService from '@/services/waiting-queue.service';

export default {
  components: {
    TheHeader,
    NotificationSystem,
    SpinnerLoading,
  },
  data() {
    return {
      global_loading: false,
      show_snackbar_vip_not_valid: false,
      status_vip: "",
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore, useGroupeStore),
  },
  watch: {
    "mainStore.module.nom": function () {
      document.title = this.mainStore.module.nom + " | Inscriptions Sportips";
    },
    "$route.params.base_module": function () {

      this.init();


    },
  },
  methods: {

    async init() {
      const base_module = this.$route.params.base_module;

      const has_admin_rights = this.mainStore.authAdmin?.isLogged;
      const current_time = this.$moment().format("HH:mm:ss");
      const override_cache_age = has_admin_rights ? current_time : null;
      await this.mainStore.initializeApp(base_module, override_cache_age);
      if (!this.mainStore.billetterie_mode) {
        this.bookingStore.initializeFromLocalStorage();
      }
      this.check_lien_groupe();


    },
    check_lien_groupe() {
      let current_page = this.$route.name;
      if (current_page == 'Home' || current_page == 'Inscriptions' || current_page == 'Cart' || current_page == 'CheckoutSuccess') {
        this.groupeStore.initializeFromLocalStorage();
      }
      else {
        this.groupeStore.clearState();
        this.groupeStore.clearLocalStorage();
      }
    },
    check_inscription_vip_validity() {
      if (!this.mainStore.inscription_vip) return;
      this.status_vip = this.mainStore.inscription_vip.get_status();
      if (!this.mainStore.inscription_vip.token) {
        this.mainStore.inscription_vip = null;
        return;
      }
      if (!this.mainStore.inscription_vip.id || !this.mainStore.inscription_vip.is_valid()) {
        this.mainStore.inscription_vip = null;
        this.show_snackbar_vip_not_valid = true;
        return;
      }
    },
    handle_check_redirection() {
      const base_module = this.$route.params.base_module;
      if (base_module == 'ROUCASS25') {
        this.$router.replace({
          ...this.$route,
          params: {
            ...this.$route.params,
            base_module: 'ROUCASS26'
          }
        });
      }
      if (base_module == 'T6C25') {
        this.$router.replace({
          ...this.$route,
          params: {
            ...this.$route.params,
            base_module: 'T6C26'
          }
        });
      }

    }

  },


  async mounted() {

    this.global_loading = true;

    this.handle_check_redirection();

    /* const wl_modules = ["TESTPPS", "TDR24"];
    && wl_modules.includes(this.$route.params.base_module) */
    if (!this.$route.query.wlwq) {
      await WaitingQueueService.init();
      setInterval(async () => {
        await WaitingQueueService.init();
      }, 60000);
    }


    await this.init();
    await this.mainStore.init_inscription_vip(this.$route.query.code_acces);
    await this.mainStore.init_inscription_vip_multi_usage(this.$route.query.code_privilege);
    this.check_inscription_vip_validity();

    this.global_loading = false;
  },

};
</script>

<style lang="scss">
@import "@/assets/scss/Global.scss";
</style>
